<template>
  <div class="rule_wrapper">
    <headTop :head-title='ruleContent.title' go-back="true" v-show="isShow==1"></headTop>
    <headTop :head-title='title' go-back="true" v-show="isShow==2" :class="{'credit-top': creditTop}"></headTop>
    <div class="news-content">
      <div class="content" v-html="ruleContent"></div>
    </div>
  </div>
</template>

<script>
  import headTop from '@/components/common/header/head'
  import { configResource } from '@/resource/resource'
  const ERR_OK = 0
  export default {
    name: 'explain',
    data () {
      return {
        ruleContent: {},
        isShow: 1,
        title: '',
        creditTop: false
      }
    },
    created () {
      this.getRule()
      if (this.$route.query.type === 'recover_rule') {
        this.isShow = 2
        this.title = '回收价格参考'
      }
      if (this.$route.query.type === 'assess_rule') {
        this.isShow = 2
        this.title = '评估价格参考'
      }
      if (this.$route.query.type === 'quota') {
        this.isShow = 2
        this.title = '关于信用管家'
        this.creditTop = true
      }
    },
    mounted () {
    },
    methods: {
      getRule () {
        configResource.config({ config: this.$route.query.type }).then(response => {
          response = response.body
          if (response.errcode === ERR_OK) {
            this.ruleContent = response.data[this.$route.query.type]
          }
        })
      }
    },
    components: {
      headTop
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .rule_wrapper
    background-color #fff
    .news-content
      margin-top 0.9rem
      height 100%
      font-size $font-size-m
      padding 0.5rem 0.2rem
      .content
        font-size $font-size-m
        margin-top 0.4rem
        line-height 0.5rem
</style>



// WEBPACK FOOTER //
// src/components/common/explain/explain.vue